<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'samplemanage-sampleStockSale',
  components: {
    PageTable,
  },
}
</script>
